import {
    ErrorResponse,
    NetworkParams,
    RestService,
} from "@sinossi/mates-react-library"

import {
    Document,
    BrandProfileUpdateRequest,
    CreateBrandResponse,
    PaginatedResponse,
    SearchFilter, ContractsBrandRequest,
} from "models"


export class BrandProfileServices
{
    static updateBrand = (brandId: string, request: BrandProfileUpdateRequest, callback: any, catchCallback: any) => {
        RestService
            .put(`/api/brand/${brandId}`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static updateLogo = (brandId: string, request: FormData, callback: any, catchCallback: any) => {
        const params = new NetworkParams()
        params.contentType = undefined

        RestService
            .genericPut(`/api/brand/${brandId}/logo`, request, params)
            .then(callback)
            .catch(catchCallback)
    }

    static getDocuments = (brandId: string, param: SearchFilter, callback: any, catchCallback: any) => {
        let searchParams: URLSearchParams = new URLSearchParams()
        searchParams.append("pageSize", "" + param.pageSize)
        searchParams.append("pageId", "" + param.pageId)

        if (param.orderType && param.orderBy){
            searchParams.append("orderType", param.orderType!.toString())
            searchParams.append("orderBy", param.orderBy!.toString())
        } else {
            searchParams.append("orderType", "ASCENDING")
            searchParams.append("orderBy", "name")
        }

        RestService
            .get<PaginatedResponse<Document>>(`/api/brand/${brandId}/document`, NetworkParams.EMPTY, searchParams)
            .then(callback)
            .catch(catchCallback)
    }
    static uploadDocument = (brandId: string, body: FormData ,callback: any, catchCallback: any) => {
        const params = new NetworkParams()
        params.contentType = undefined

    RestService
        .genericPost<any, ErrorResponse>(`/api/brand/${brandId}/document`, body, params)
        .then(callback)
        .catch(catchCallback)
    }

    static deleteDocument = (brandId: string, documentId: string, callback: any, catchCallback: any) => {
        RestService
            .delete(`/api/brand/${brandId}/document/${documentId}`)
            .then(callback)
            .catch(catchCallback)
    }

    static getMatch = (brandId: string, request: SearchFilter, callback: any, catchCallback: any) => {
        RestService
            .post<CreateBrandResponse>(`/api/brand/${brandId}/match`,request)
            .then(callback)
            .catch(catchCallback)
    }

    static getContracts = (brandId: string, request: ContractsBrandRequest, callback: any, catchCallback: any) => {
        RestService
            .post(`/api/brand/contracts`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static flagVisibility = (brandId: string, callback: any, catchCallback: any) => {
        RestService
            .post(`/api/brand/${brandId}/visibility`, brandId)
            .then(callback)
            .catch(catchCallback)
    }
}
